<template>
<div>
  <div class="wistia_embed wistia_async_jo4lhisvp5">
    &nbsp;
  </div>

  <div
    id="choose_administrator"
    class="tbk-vid-embed"
  >
    <a
      id="keys_cecilia"
      class="embedded_video"
      href="#wistia_26ncwyx5qd?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="keys_fatuma"
      class="embedded_video"
      href="#wistia_g1jam5d36h?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="keys_julia"
      class="embedded_video"
      href="#wistia_ik1j4id3i5?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="keys_patina"
      class="embedded_video"
      href="#wistia_a7c7vr9x8p?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('jo4', 0, this.showSelect)

    this.tbk.loadCrossTime('26n', 99, this.showSelect)
    this.tbk.loadCrossTime('g1j', 143, this.showSelect)
    this.tbk.loadCrossTime('ik1', 65, this.showSelect)
    this.tbk.loadCrossTime('a7c', 117, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '26n': this.tbk.autoPlay,
        g1j: this.tbk.autoPlay,
        ik1: this.tbk.autoPlay,
        a7c: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#choose_administrator
  display: none
  a
    text-decoration: none
#keys_cecilia
  position: absolute
  top: 0
  left: 0
  width: 25%
  height: 100%
#keys_fatuma
  position: absolute
  top: 0
  left: 25%
  width: 25%
  height: 100%
#keys_julia
  position: absolute
  top: 0
  left: 50%
  width: 25%
  height: 100%
#keys_patina
  position: absolute
  top: 0
  left: 75%
  width: 25%
  height: 100%
</style>
